module.exports = __webpack_public_path__ + "static/img/f_3.6e04b0c6.png";